<template>
    <transition name="modal">
        <b-modal ref="audio-format-modal" id="audio-format-modal">
            <div slot="modal-title" class="text-center">
                Choose an Audio Format
            </div>           

            <p>How would you like to have your files delivered?</p>

            <b-form-group label="Choose a System/Provider">
                <multiselect 
                    v-model="systemsVal" 
                    :allowEmpty="true" 
                    :options="systemProviders" 
                    label="name"
                    selectLabel=""
                    selectedLabel=""
                    deselectLabel=""
                    @input="setProvider"
                    >
                </multiselect>
            </b-form-group>

            <p>Or, if you know the format pick from the list below.</p>

            <b-form-group>
                <multiselect 
                    v-model="formatsVal" 
                    :allowEmpty="true" 
                    :options="formats" 
                    label="name"
                    selectLabel=""
                    selectedLabel=""
                    deselectLabel=""
                    @input="setFormat"
                    >
                </multiselect>
            </b-form-group>

            <div slot="modal-footer">
                <b-button type="submit" class="float-right" variant="primary" size="sm" @click="submit">Submit</b-button>
            </div>
        </b-modal>
    </transition>
</template>

<script>      
    import Multiselect from 'vue-multiselect'
    import {mapGetters} from 'vuex'
    export default {
        components: {Multiselect},
        props: {
            value: {
                type: Object,
                default: function () {
                    return {name: null, id: null}
                }
            }
        },
        data() {
            return {
                formatsVal: null,
                systemsVal: null
            }
        },
        watch: {
            value () {
                this.systemsVal = this.systemProviders.find(system => this.value && system.id === this.value.id)
                this.formatsVal = this.formats.find(format => this.value && format.id === this.value.id)
            }
        },
        methods: {
            submit () {
                if (!this.format) {
                    this.$bvModal.hide('audio-format-modal')
                }

                this.$store.commit('project/setFormat', this.format)

                this.$bvModal.hide('audio-format-modal')
                this.$emit('FormatSet')
            },
            setProvider (val) {
                this.formatsVal = null
            },
            setFormat (val) {
                this.systemsVal = null
            }
        },
        computed: {
            ...mapGetters({
                formats: 'tag/formats',
                systemProviders: 'tag/systemProviders'
            }),
            format () {null
                if (!this.formatsVal && !this.systemsVal)
                    return 

                return (this.formatsVal) ? this.formatsVal : this.systemsVal
            }
        },
    }
</script>



// WEBPACK FOOTER //
// prompts/components/modals/AudioFormatModal.vue